

import React, { useState } from "react";
import "./technologies.css";

// technolgies image

import ReactLogo from "../../assets/technolgies/reactjs.svg";
import NextJSLogo from "../../assets/technolgies/next.js.a232475a.svg";
import AngularJSLogo from "../../assets/technolgies/angular.js.60989ab0.svg";
import JavascriptLogo from "../../assets/technolgies/js.8efe4b99.svg";
import PythonLogo from "../../assets/technolgies/python.69492701.svg";
import PhpLogo from "../../assets/technolgies/php.104f67c6.svg";
import MySqlLogo from "../../assets/technolgies/mysql.svg";
import PostSqlLogo from "../../assets/technolgies/postgre.svg";
import FireBaseLogo from "../../assets/technolgies/firebase.svg";

const allTechnologiesWeWorked = {
  frontend: [
    {
      src:ReactLogo,
      title: "React JS",
      description: "A JavaScript library for building UIs",
    },
    {
      src: JavascriptLogo,
      title: "JavaScript",
      description: "scripting language used to create interactive web pages",
    },
     {
      src: NextJSLogo,
      title: "Next JS",
      description: "React framework for fast, SEO-friendly web apps.",
    },
     {
      src: AngularJSLogo,
      title: "Angular",
      description: "A TypeScript-based framework for building dynamic web apps.",
    },
    {
      src: "https://upload.wikimedia.org/wikipedia/commons/9/96/Sass_Logo_Color.svg",
      title: "Sass",
      description: "CSS preprocessor scripting language",
    },
      {
      src: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg",
      title: "Tailwind CSS",
      description: "CSS preprocessor scripting language",
    },
  ],
  backend: [
    {
      src: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg",
      title: "Node.js",
      description:"A JavaScript runtime for building fast, server-side applications.",
    },
    {
      src: PythonLogo,
      title: "Python",
      description: "A high-level Python web framework",
    },
    {
      src: "https://upload.wikimedia.org/wikipedia/commons/6/64/Expressjs.png",
      title: "Express.js",
      description: "Minimal and flexible Node.js web framework",
    },
    {
      src: PhpLogo,
      title: "Php",
      description: "Minimal and flexible Node.js web framework",
    },
  ],
  cms: [
    {
      src: "https://upload.wikimedia.org/wikipedia/commons/9/93/Wordpress_Blue_logo.png",
      title: "WordPress",
      description: "A popular CMS for building websites",
    },
    {
      src: "https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg",
      title: "Figma",
      description: "Collaborative interface design tool",
    },
  ],
  database: [
    {
      src: "https://upload.wikimedia.org/wikipedia/commons/8/87/Sql_data_base_with_logo.png",
      title: "SQL",
      description: "Relational database management system",
    },
    {
      src: "https://upload.wikimedia.org/wikipedia/en/4/45/MongoDB-Logo.svg",
      title: "MongoDB",
      description: "NoSQL document database",
    },
    {
      src: MySqlLogo,
      title: "MySQL",
      description: "Relational database management system",
    },
    {
      src: PostSqlLogo,
      title: "PostSqlLogo",
      description:"A reliable open-source relational database",
    },
    {
      src:FireBaseLogo,
      title: "Firebase",
      description : "Cloud-hosted NoSQL database service",
    }
  ],
  ecommerce:[
    {
      src:FireBaseLogo,
      title: "Firebase",
      description : "Cloud-hosted NoSQL database service",
    }
  ]
};


// Main Components----------------------
const TechnologiesWeOfferMainComponents = () => {
  const [activeTab, setActiveTab] = useState("frontend");

  return (
    <section className="technologies_Section">
      <div className="container">
        {/* <h5 className="industriesTitle">-- What We’re Offering to Our Clients</h5> */}
        <h1 className="technologiesTitlHeading">Technologies We Work On</h1>
        <p className="technologiesWeWorkDescription">
         StarlinkLab delivers modern, scalable digital solutions using technologies like React.js, 
         Node.js, Shopify, and WordPress—helping businesses grow with smart, future-ready tech.
        </p>

        <hr className="divider" />

        <div className="tab-container">
          {Object.keys(allTechnologiesWeWorked).map((key) => (
            <button
              key={key}
              className={activeTab === key ? "active-tab" : "tab"}
              onClick={() => setActiveTab(key)}
            >
              {key.toUpperCase()}
            </button>
          ))}
        </div>
        <div className="outer-wrapper">
          <div className="technologies-container">
            {allTechnologiesWeWorked[activeTab].map((technologies, index) => (
              <div key={index} className="technologies-item">
                <div className="inner-content">
                  <img src={technologies.src} alt={technologies.title} className="technologies-image" />
                  <h4 className="technologies-title">{technologies.title}</h4>
                  <p className="technologies-description">{technologies.description}</p>
                </div>
                
              </div>
            ))}
          </div>
           <p className="mt-4 text-lg text-gray-400 quote">
            “Bringing Your Bright Ideas to Life with Technology”
          </p>
        </div>
      </div>
    </section>
  );
};

export default TechnologiesWeOfferMainComponents;
